import { render, staticRenderFns } from "./TabelaGerenciamentoToken.vue?vue&type=template&id=179d42bd"
import script from "./TabelaGerenciamentoToken.vue?vue&type=script&lang=js"
export * from "./TabelaGerenciamentoToken.vue?vue&type=script&lang=js"
import style0 from "./TabelaGerenciamentoToken.vue?vue&type=style&index=0&id=179d42bd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports